import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";
import { useI18n } from "../lib/i18n";

const AuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { t } = useI18n();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // The backend already set the session cookie via the Google OAuth redirect.
        // We just need to fetch the current user.
        const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
        setUser(response.data);
        toast.success(t("auth.loginSuccess"));

        if (response.data.role === "therapist") {
          navigate("/therapist", { replace: true });
        } else {
          navigate("/patient", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error(t("auth.authError") || "Erreur d'authentification");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, setUser, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 animate-pulse">
        <img src="/logo-kintsugi.png" alt="Kintsugi TCC" className="w-14 h-auto" />
        <p className="text-muted-foreground">{t("auth.authenticating") || "Authentification..."}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
